import { useUiImage } from '@/ui/art/uiArt';
import { Icon } from './Icon';

/** Painted currency/HUD icons (glossary §4.5: coins/stars are drawn icons, never emoji). */
export function CoinIcon({ size = 20 }: { size?: number }) {
  return <Icon name="coin" size={size} />;
}

export function StarIcon({ size = 20 }: { size?: number }) {
  return <Icon name="star" size={size} />;
}

export function HeartIcon({ size = 20 }: { size?: number }) {
  return <Icon name="heart" size={size} />;
}

export function UndoIcon({ flip = false }: { flip?: boolean }) {
  return <Icon name="undo" size={24} flip={flip} />;
}

/** Speaker for the sound toggles (HUD, S22 top bar); crossed out when muted. */
export function SpeakerIcon({ muted }: { muted: boolean }) {
  return <Icon name={muted ? 'sound_off' : 'sound_on'} size={26} />;
}

/** The S21 intro card picture (asset-list B7 `mg_intro_*`); the game's icon until the art has loaded. */
const MINIGAME_ART = {
  mg_dusting: { image: 'mg_intro_dusting', icon: 'dusting' },
  mg_packing: { image: 'mg_intro_packing', icon: 'packing' },
  mg_cooking: { image: 'mg_intro_cooking', icon: 'cooking' },
} as const;

export function MiniGameArt({ game }: { game: keyof typeof MINIGAME_ART }) {
  const url = useUiImage(MINIGAME_ART[game].image);
  return url ? (
    <img
      src={url}
      width={160}
      height={160}
      alt=""
      aria-hidden="true"
      draggable={false}
      style={{ objectFit: 'contain' }}
    />
  ) : (
    <Icon name={MINIGAME_ART[game].icon} size={96} />
  );
}

/** Small padlock on a locked chip; `label` is read out instead of the picture. */
export function LockIcon({ label }: { label: string }) {
  return (
    <span role="img" aria-label={label} style={{ display: 'inline-flex', marginLeft: 4 }}>
      <Icon name="lock" size={18} />
    </span>
  );
}
